// extracted by mini-css-extract-plugin
module.exports = {"laser":"Laser_laser___F8eV","pulsate":"Laser_pulsate__4AqxT"};